import React from 'react';
import { useTranslation } from 'react-i18next';
import { keyMap } from '@locales/lokalise/keyMap';
import cn from 'classnames';
import { DEVICE_ENUM } from 'global.enums';
import { DeviceType } from 'global.interfaces';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';
import styles from './styles.module.scss';

export const MetaServerInfo = observer(({ deviceType }: { deviceType: DeviceType }) => {
  const { i18n } = useTranslation();
  const { accountStore } = useMobxStore();
  const additionalClass = deviceType === DEVICE_ENUM.DESKTOP ? styles.desktop : styles.mobile;

  return (
    <div className={cn(styles.metaServerInfo, additionalClass)}>
      {i18n.t(keyMap.menuServerTime)} {accountStore.utcOffsetInHoursFormattedString}
    </div>
  );
});
